import { element } from 'prop-types';
import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Dashboards

const Servers = Loader(lazy(() => import('src/content/dashboards/Servers')));
const Helpdesk = Loader(lazy(() => import('src/content/dashboards/Helpdesk')));
const Products = Loader(lazy(() => import('src/content/dashboards/Products')));
const Invoices = Loader(lazy(() => import('src/content/dashboards/Invoices')));
const ProductDetails = Loader(lazy(() => import('src/content/dashboards/Products/ProductDetail')));
const ServerTelemetry = Loader(lazy(() => import('src/content/dashboards/Servers/Telemetry')));

const dashboardsRoutes = [
  {
    path: '/reports',
    element: <Servers />
  },
  {
    path: '/',
    element: <Navigate to="control" replace />
  },
  {
    path: 'control',
    element: <Servers />
  },
  {
    path: 'control/servers/:serverId/telemetry',
    element: <ServerTelemetry />
  },
  {
    path: 'products',
    children:[
      {
        path:"/",
        element:<Products/>
      },
      {
        path:"single",
        children:[
          {
            path:"/",
            element:<Navigate to="0" replace />
          },
          {
            path:":qr_code",
            element:<ProductDetails/>
          }
        ]
      }
    ]
  },
  {
    path: 'helpdesk',
    element: <Helpdesk/>
  },
  {
    path: 'invoices',
    element: <Invoices/>
  },
  {
    path: 'sales',
    element: <Navigate to="/status/coming-soon" replace />
  }
];

export default dashboardsRoutes;
